export default function isEmbedded() {
  return window.TMF_CONFIG?.embedded === true;
}
